<template>
  <transition :duration="{ enter: 5000, leave: 500 }"
              name="slide-fade"
              @after-enter="removeErrors">
    <div v-if="hasErrors" class="alert alert-danger">
      <ul>
        <li v-for="(error, index) in serverErrors" :key="'error_' + index">
          {{ error }}
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ServerErrors',
  methods: {
    ...mapActions({
      removeErrors: 'users/removeErrors'
    })
  },
  computed: {
    ...mapGetters({
      hasErrors: 'users/hasErrors',
      serverErrors: 'users/errors',
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/form/ServerErrors.vue